import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { ConnatixLiveStreamResponse } from './entities';
import { Session } from '@benzinga/session';
import { LivestreamEnvironment } from './environment';

export class LivestreamRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(LivestreamEnvironment).url, session, { 'x-device-key': true });
  }

  getConnatixLivestream = (): SafePromise<ConnatixLiveStreamResponse> => {
    const url = this.URL('live-stream/connatix');
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin' });
  };
}
